import { render, staticRenderFns } from "./Doors.vue?vue&type=template&id=296c23f3&scoped=true"
import script from "./Doors.vue?vue&type=script&lang=js"
export * from "./Doors.vue?vue&type=script&lang=js"
import style0 from "./Doors.vue?vue&type=style&index=0&id=296c23f3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "296c23f3",
  null
  
)

export default component.exports